// file-upload.facade.ts
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { concatMap, map, toArray } from 'rxjs/operators';
import {UploadFileFG} from "../../../core/model/nachricht-form";
import {FileSanitizeService} from "./file-validation/file-sanitize.service";
import {FileValidationService} from "./file-validation/file-validation.service";
import {UploadFormFactory} from "../upload-form-factory";
import {ValidationResult} from "./file-validation/validation-result";


interface ProcessedFile {
    file: File;
    formGroup: UploadFileFG;
    isValid: boolean;
}


@Injectable({ providedIn: 'root' })
export class FileUploadFacade {
    constructor(
        private readonly sanitizer: FileSanitizeService,
        private readonly validator: FileValidationService,
        private readonly factory: UploadFormFactory
    ) {}


    /**
     * Für jede Datei:
     * - sanitize name
     * - validate → ValidationResult
     * - formFactory: ERROR oder LOADING-Group
     */
    processFiles(files: File[]): Observable<ProcessedFile[]> {
        return from(files).pipe(
            concatMap(orig => {
                const safeName = this.sanitizer.replaceInvalidFilenameChars(orig.name);
                const file = new File([orig], safeName, {
                    type: orig.type,
                    lastModified: orig.lastModified
                });


                return this.validator.validate(file).pipe(
                    map((res: ValidationResult) => {
                        const isValid = res.isValid;
                        const formGroup = isValid
                            ? this.factory.createUploading(file.name)
                            : this.factory.createError(file.name, res.messageKey);
                        return { file, formGroup, isValid } as ProcessedFile;
                    })
                );
            }),
            toArray()
        );
    }
}